<template>
  <div>
    <div class="text-right">
      <button
        class="mb-2 bg-green px-4 py-2 text-white shadow-md rounded-sm font-normal"
        @click="showAnnoucementModal"
      >
        Create Announcement (c)
      </button>
    </div>

    <Table
      ref="announcementTable"
      :endpoint="endpoint"
      :tableConfig="tableConfig"
    />
    <VModal
      name="announcement-modal"
      :click-to-close="false"
      width="1000"
      height="98%"
      class="email-modal"
    >
      <AnnouncementEditor
        :announcementEditObj="announcementEditObj"
        @discard-modal="discardModal"
        @announcement-created="handleAnnouncementCreation"
      />
    </VModal>
  </div>
</template>

<script>
import { format, parseISO } from "date-fns"
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"
import AnnouncementEditor from "@/components/Notification/AnnouncementEditor"

export default {
  components: {
    Table,
    AnnouncementEditor,
  },
  data() {
    return {
      announcementEditObj: null,
      endpoint: `${siteConfig.siteURL}notifications/announcements`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          classList: "w-1/3",
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Status", sortingParam: "status" },
          path: "/",
          formatter: ({ status, sent_on, scheduled_for }) => {
            let labelText = status
            let className = ""
            if (status === "failed") {
              className = "text-red"
            } else if (status === "sent") {
              className = "text-green"
              labelText = `Sent on:<br/>${format(
                parseISO(sent_on),
                "hh:mm aaa, dd/MM/yyyy"
              )}`
            } else if (status === "drafted") {
              className = "text-blue-dark"
            } else if (status === "scheduled") {
              labelText = `Scheduled for:<br/>${format(
                parseISO(scheduled_for),
                "hh:mm aaa, dd/MM/yyyy"
              )}`
            }

            return `<span class="${className} rounded-sm">${labelText}</span>`
          },
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },

        {
          header: { textContent: "Duplicate" },
          path: "id",
          type: "button",
          classList:
            "copy-button rounded-sm m-0 flex justify-center items-center",
          buttonText: `<svg xmlns="http://www.w3.org/2000/svg" height="20" fill="grey" viewBox="-40 0 512 512" width="20"><path d="m271 512h-191c-44.113281 0-80-35.886719-80-80v-271c0-44.113281 35.886719-80 80-80h191c44.113281 0 80 35.886719 80 80v271c0 44.113281-35.886719 80-80 80zm-191-391c-22.054688 0-40 17.945312-40 40v271c0 22.054688 17.945312 40 40 40h191c22.054688 0 40-17.945312 40-40v-271c0-22.054688-17.945312-40-40-40zm351 261v-302c0-44.113281-35.886719-80-80-80h-222c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h222c22.054688 0 40 17.945312 40 40v302c0 11.046875 8.953125 20 20 20s20-8.953125 20-20zm0 0"/></svg>`,
          onclick: id => {
            this.requestAnnouncementDuplication(id)
          },
        },
        {
          header: { textContent: "Edit" },
          path: "/",
          type: "button",
          classList: "rounded-sm m-0 edit-button",
          buttonText: `Edit`,
          onclick: announcement => {
            this.editAnnouncement(announcement)
          },
        },
      ],
    }
  },
  mounted() {
    document.addEventListener("keypress", e => this.handleKeypress(e))
  },
  methods: {
    handleAnnouncementCreation(data) {
      this.announcementEditObj = data
      this.refreshTable()
    },
    refreshTable() {
      this.$refs.announcementTable.getItems()
    },
    handleKeypress(e) {
      if (
        e.target.nodeName !== "INPUT" &&
        e.target.nodeName !== "TEXTAREA" &&
        e.code === "KeyC"
      ) {
        this.showAnnoucementModal()
      }
    },
    editAnnouncement(announcement) {
      this.announcementEditObj = announcement
      this.showAnnoucementModal()
    },
    requestAnnouncementDuplication(announcement_id) {
      console.log(announcement_id)
    },
    showAnnoucementModal() {
      this.$modal.show("announcement-modal")
    },
    hideModal() {
      this.$modal.hide("announcement-modal")
    },
    discardModal() {
      this.announcementEditObj = null
      this.hideModal()
    },
  },
}
</script>

<style></style>
